import React from 'react'

const Welcome = () => {
  return (
    <h1>Welcome</h1>
  )
}

export default Welcome